import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',

    '@media screen and (min-width: 1100px)': {
      height: '100% !important',
      minHeight: 'calc(100vh - 80px - 40px)',
      overflow: 'hidden',
    },

    '@media screen and (max-width: 700px)': {
      minHeight: '100%',
      marginTop: 0,
    }
  },
  sectionHome:{
    height: 'calc(100vh - 80px)',
    display:'flex',
    alignItems:'center',
    justifyContent: 'center',
    width: '100%',

    '@media screen and (max-width: 700px)': {
      height: '100%',
      marginTop: 0,
    }
  },
  containerSkeleton: {
    display: 'flex',
  },
  title: {
    color: 'white',
    fontWeight: 'bolder !important',
    textAlign: 'start',
    margin: 0,
    paddingBottom: 10,
  },

  containerProfs: {
    height: '100%',
    padding: '20px 10px',
  },

  cardCarousel: {
    margin: '16px',
    maxWidth: '1200px',
    height: '100%',
    width: '100%',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100% - 32px)',

    '@media screen and (max-width: 700px)': {
      maxHeight: '100% !important',
    },
    overflowY: 'auto',
    backgroundColor: '#035ea7',

    [theme.breakpoints.down('700')]: {
      display: 'grid',
    }
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    background: '#035ea7',
    padding: '5px 10px',
    gap: 5,
    flexWrap: 'wrap',
  },
  containerForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10,
    padding: '10px 0',
  },
  gridContainer: {
    display:'grid',
    gridTemplateColumns:'repeat(4,1fr)',
    gap: 10,
  },
  more: {
    minWidth: '250px !important',
    marginTop: '20px !important',
    marginBottom: '10px !important',
  },

  card: {
    margin: '16px',
    width: '860px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100% - 32px)',
    overflowY: 'scroll',
    backgroundColor: '#035ea7',

    [theme.breakpoints.down('700')]: {
      display: 'grid',
    }
  },

  text: {

    height: '100%',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '20px 70px',
    

    '& > div': {
      backgroundColor: '#035ea7',
      boxShadow: '0 0 50px #035ea7, 0 0 50px #035ea7, 0 0 50px #035ea7, 0 0 50px #035ea7',

      borderRadius: 60,
      padding: 16,

      '@media screen and (max-width: 700px)': {
        marginTop: 16,
        padding: 0,
      },

      '& h1': {
        margin: 0,
        paddingBottom: 32,
      },
      '& p': {
        color: 'white',
        margin: 0,
        padding: 16,
        textAlign: 'center',

        '@media screen and (max-width: 700px)': {
          marginTop: 16,
          padding: 0,
        }
      },
    },


    [theme.breakpoints.down('700')]: {
      padding: 16,
      height: 'auto',
      '& h1, & p': {
        padding: 0,
      },

    },
  },

  links: {
    display: 'flex',
    gap: 8,
    padding: 8,

    [theme.breakpoints.down('700')]: {
      flexDirection: 'column',
      height: 'auto',
    },

    '& a': {
      textDecoration: 'none',
      [theme.breakpoints.down('700')]: {
        height: '100%',
      },
      display: 'grid',
      placeItems: 'center',
      width: '100%',

      [theme.breakpoints.up('700')]: {
        '&:hover > div': {
          transform: 'translateY(-8px)',
        }
      },
      
    },

    '& a > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      backgroundColor: 'white',
      borderRadius: 8,
      height: 200,
      width: '100%',
      transition: 'transform ease .2s',

      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },

      [theme.breakpoints.down('700')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: 100,
        '& > div': {
          width: 'inherit',
          marginLeft: '20px'
        }
      },


    },

    '& > a:nth-child(1)': {
      '& *': {
        color: '#005d7f'
      },
      '& h3': {
        backgroundColor: '#005d7f44'
      },
      '&:hover': {
        boxShadow: '0 0 20px #005d7f44',
        zIndex: 1000
      }
    },
    '& > a:nth-child(2)': {
      '& *': {
        color: '#728f23'
      },
      '& h3': {
        backgroundColor: '#728f2344'
      },
      '&:hover': {
        boxShadow: '0 0 20px #728f2344',
        zIndex: 1000
      }
    },
    '& > a:nth-child(3)': {
      '& *': {
        color: '#5a5859'
      },
      '& h3': {
        backgroundColor: '#5a585944'
      },
      '&:hover': {
        boxShadow: '0 0 20px #5a585944',
        zIndex: 1000
      }
    },
    '& > a:nth-child(4)': {
      '& *': {
        color: '#035EA7'
      },
      '& h3': {
        width: 'fit-content',
        backgroundColor: '#A9D9FF'
      },
      '&:hover': {
        boxShadow: '0 0 20px #5a585944',
        zIndex: 1000
      }
    },

    '& svg': {
      fontSize: '5rem',
    },

    '& h3, & h4': {
      margin: 0,
    },

    '& h3': {
      color: 'rgba(0,0,0,.6)',
      padding: '4px 12px',
      fontSize: 15,
      textTransform: 'uppercase',
      marginTop: 20,
      marginBottom: 8,
      borderRadius: 99,

    },

    '& h4': {
      color: 'rgba(0,0,0,.6)',
      fontSize: 13,
      padding: '5px'
    },
  }

}))
